module.exports = __webpack_public_path__ + "static/img/gu.2284e60e.svg";